"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FieldConfigSchema () {
        return FieldConfigSchema;
    },
    get OperatorSchema () {
        return OperatorSchema;
    },
    get SearchField () {
        return SearchField;
    },
    get ServiceSearchFieldsSchema () {
        return ServiceSearchFieldsSchema;
    },
    get TypeSchema () {
        return TypeSchema;
    },
    get debugSchema () {
        return debugSchema;
    }
});
const _zod = require("zod");
const OperatorSchema = _zod.z.enum([
    "eq",
    "re",
    "in",
    "nin",
    "ne",
    "gt",
    "lt",
    "gte",
    "lte",
    "all"
]);
const TypeSchema = _zod.z.enum([
    "string",
    "number",
    "objectid",
    "objectid[]",
    "string[]",
    "date",
    "boolean"
]);
const FieldConfigSchema = _zod.z.object({
    operators: OperatorSchema.array(),
    type: TypeSchema
});
const ServiceSearchFieldsSchema = _zod.z.record(FieldConfigSchema);
const SearchField = _zod.z.object({
    field: _zod.z.string(),
    operator: OperatorSchema,
    value: _zod.z.any()
});
const debugSchema = _zod.z.object({
    searchFieldsAndOperators: SearchField.array(),
    skip: _zod.z.number(),
    limit: _zod.z.number(),
    sort: _zod.z.record(_zod.z.string(), _zod.z.union([
        _zod.z.literal(1),
        _zod.z.literal(-1)
    ])).optional()
});
